// extracted by mini-css-extract-plugin
export default {"Vcard":"Transaction_Vcard__UaWoX","VAcctTxt":"Transaction_VAcctTxt__trAR0","VFundTxt":"Transaction_VFundTxt__qRE+R","VBank":"Transaction_VBank__s8O1d"};